import CircularProgress from '@material-ui/core/CircularProgress';
import React from 'react';

import AccountsPayableFooter from '@components/AccountsPayableFooter';
import AccountsPayableLoader from '@components/AccountsPayableLoader';
import Header from '@components/header';

import { LayoutProps } from '../types';
import useStyles from './styles';
import useStore from '@hooks/useStore';

const GuestLayout: React.FunctionComponent<LayoutProps> = ({
  loading = false,
  isAccountsPayable = false,
  ...props
}) => {
  const {
    links: {
      coBrandingConfig: { primaryColor, secondaryColor },
    },
    sura,
  } = useStore();
  const css = useStyles({ primaryColor, secondaryColor });

  const loadingContentClasses = loading ? css.centered : '';
  const loader = isAccountsPayable ? (
    <AccountsPayableLoader />
  ) : (
    <CircularProgress className={css.progress} />
  );

  return (
    <div className={css.root}>
      <Header flat={sura.isSura ? false : true} />
      <main className={`${css.content} ${loadingContentClasses}`}>
        {loading ? loader : props.children}
      </main>
      {isAccountsPayable && <AccountsPayableFooter />}
    </div>
  );
};

export default GuestLayout;
